import { Separator } from '@base-ui-components/react/separator'
import type { FC, HTMLAttributes } from 'react'
import styles from './divider.module.css'

export interface TunaDividerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  orientation?: 'horizontal' | 'vertical'
  children?: React.ReactNode
}

export const TunaDivider: FC<TunaDividerProps> = ({
  orientation = 'horizontal',
  className,
  children,
  ...rest
}) => {
  if (children) {
    const classes = [styles.withText, className].filter(Boolean).join(' ')
    return (
      <div className={classes} role="separator" {...rest}>
        {children}
      </div>
    )
  }

  const classes = [
    styles.divider,
    orientation === 'vertical' ? styles.vertical : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <Separator className={classes} orientation={orientation} {...rest} />
}
